import React from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from 'react-responsive'
import { ErrorBoundary } from 'react-error-boundary'
import { Button, Grid, TextField, Typography } from '@material-ui/core'
import { RECOVER_FROM_ERROR_STATE } from '../../constants/ClearStoreActionType'
import NavigationBar from '../common/NavigationBar'
import TwoFactorSetup from '../IAM/TwoFactorSetup'
import TwoFactor from '../IAM/TwoFactor'
import { MigrationNotice } from '../Migration'

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5)
    },
    footerMobile: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(2)
    },
    footer: {
        marginLeft: theme.spacing(5),
        marginTop: theme.spacing(2)
    },
}));

let errorStack = ''
let errorInfo = ''

function myErrorHandler(error, info) {
    errorStack = error
    errorInfo = info
}

function Bomb() {
    throw new Error('💥💥💥 ErrorBoundary ISSUE TEST EMAIL 💥💥💥')
}

const responsiveData = () => {
    let desktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' })
    let system = useMediaQuery({ query: '(max-width: 1024px)' })
    let tablet = useMediaQuery({ query: '(max-width: 768px)' })
    let notMobile = useMediaQuery({ query: '(min-width: 450px)' })
    let mobile = useMediaQuery({ query: '(max-width: 450px)' })
    let portrait = useMediaQuery({ query: '(orientation: portrait)' })

    return { isDesktopOrLaptop: desktopOrLaptop, isSystem: system, isTablet: tablet && notMobile, isMobile: mobile, isPortrait: portrait }
}

const MainLayout = ({ profile, pages, component }) => {
    const classes = useStyles()
    const dispatch = useDispatch();
    const [twoFactorOpen, setTwoFactorOpen] = React.useState(profile.twofactor)
    const responsive = responsiveData()

    function ErrorFallback({ error, resetErrorBoundary }) {
        const [reportError, setReportError] = React.useState(false)
        const [errorReproductionSteps, setErrorReproductionSteps] = React.useState("")
        const mailURL = "mailto:chandra.poojari@ericsson.com;kumar.ray@ericsson.com?subject=" + error.message + '&body=Error Reproduction Steps:%0D%0A%0D%0A' + errorReproductionSteps.replace(/\n/g, '%0D%0A') + '%0D%0A%0D%0AError Message: ' + errorStack + '%0D%0A%0D%0AError Stack:%0D%0A' + JSON.stringify(errorInfo).replace(/\\n/g, '%0D%0A');

        return (
            <Grid className={classes.root} container direction="column" justify="center" alignItems="stretch" spacing={2}>
                <Grid item>
                    <Typography variant={'h3'}>Something went wrong.</Typography>
                    <Typography variant={'h3'}>Report to system administrator below if the issue occurs again.</Typography>
                    <Typography variant={'h5'}>{error.message}</Typography>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="center" xs={10}>
                        <Grid item><Button variant='contained' onClick={resetErrorBoundary}>Reset</Button></Grid>
                        <Grid item><Button variant='contained' onClick={() => setReportError(true)}>Report Issue</Button></Grid>
                    </Grid>
                </Grid>
                {
                    reportError ? (
                        <Grid item>
                            <Grid container direction="column" justify="center" alignItems="stretch" xs={10}>
                                <Grid item><TextField id={'issue_reproduce'} variant="outlined" label="Steps to reproduce the error" rows={20} fullWidth multiline onChange={(e) => { setErrorReproductionSteps(e.target.value) }} /></Grid>
                                <Grid item container style={{ margin: '10px' }} direction="row" justify="flex-end" alignItems="center">
                                    <Grid item><Button variant='contained' onClick={() => setReportError(false)}>Cancel</Button></Grid>
                                    <Grid item><Button variant='contained' href={mailURL}>Submit Issue</Button></Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : null
                }
            </Grid>
        )
    }

    const Component = component

    return (
        <React.Fragment>
            <NavigationBar pages={pages} profile={profile} responsive={responsive} />
            <MigrationNotice canMigrate={profile.status === 'LOGGED_IN'} />
            <main>
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={myErrorHandler} onReset={() => dispatch({ type: RECOVER_FROM_ERROR_STATE })}>
                    <Component profile={profile} responsive={responsive} />
                </ErrorBoundary>
            </main>
            <Typography className={responsive.isMobile ? classes.footerMobile : classes.footer} variant="h6">{"Ericsson Support Protal "}&copy;{" Ericsson Inc. "}{new Date().getFullYear()}</Typography>
            <TwoFactor profile={profile} />
            <TwoFactorSetup profile={profile} open={twoFactorOpen === 0} onClose={() => setTwoFactorOpen(1)} />
        </React.Fragment>
    )
}

export default MainLayout
